import { createAsyncAction, createAction } from "typesafe-actions";
import { SensorListItem } from "@shared/models";
import { PaginatedResponse, SensorFilter, UpdateStatusShape } from "@shared/interfaces";

import { SensorActionTypes } from "./constants";
import { CreateSensorDto, CreateSensorSuccess } from "../interfaces";

export const getSensors = createAsyncAction(
  SensorActionTypes.GET_SENSORS,
  SensorActionTypes.GET_SENSORS_SUCCESS,
  SensorActionTypes.GET_SENSORS_FAILURE,
)<SensorFilter, PaginatedResponse<SensorListItem>, Error>();

export const createSensor = createAsyncAction(
  SensorActionTypes.CREATE_SENSOR,
  SensorActionTypes.CREATE_SENSOR_SUCCESS,
  SensorActionTypes.CREATE_SENSOR_FAILURE,
)<CreateSensorDto, CreateSensorSuccess, Error>();

export const updateSensor = createAsyncAction(
  SensorActionTypes.UPDATE_SENSOR,
  SensorActionTypes.UPDATE_SENSOR_SUCCESS,
  SensorActionTypes.UPDATE_SENSOR_FAILURE,
)<CreateSensorDto & { id: number }, CreateSensorSuccess, Error>();

export const updateSensorStatus = createAsyncAction(
  SensorActionTypes.UPDATE_SENSOR_STATUS,
  SensorActionTypes.UPDATE_SENSOR_STATUS_SUCCESS,
  SensorActionTypes.UPDATE_SENSOR_STATUS_FAILURE,
)<UpdateStatusShape, CreateSensorSuccess, Error>();

export const setFilter = createAction(SensorActionTypes.SET_FILTER)<SensorFilter | null>();
export const clearSensors = createAction(SensorActionTypes.CLEAR_SENSORS)();
